var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-header',{staticClass:"asc-section-header",attrs:{"value":_vm.title,"size":"h3","no-margins":"","uppercase":""}})}
var staticRenderFns = []

export { render, staticRenderFns }